import { render } from "./MultiTagField.vue?vue&type=template&id=7bb8dae4"
import script from "./MultiTagField.vue?vue&type=script&lang=js"
export * from "./MultiTagField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__